import React from 'react';

const LocationOverview = () => {
  return (
    <section className="bg-[#F9F6F0] py-20 px-6 md:px-12 lg:px-20 border-t border-[#5c1d24]/10">
      <div className="max-w-5xl mx-auto">
        
        {/* Main Flex Row: Balances Location on left, Timings on right */}
        <div className="flex flex-col md:flex-row items-start justify-between gap-12 md:gap-6">
          
          {/* Left Column: Studio Location Details */}
          <div className="space-y-4 max-w-md">
            <span className="text-xs font-semibold uppercase tracking-widest text-[#5c1d24] bg-[#5c1d24]/5 px-3 py-1 rounded-sm">
              आमचे दालन • Our Studio
            </span>
            <h3 className="font-serif text-2xl md:text-3xl text-neutral-900 tracking-wide font-medium pt-1">
              Tuljai Nauvari Boutique
            </h3>
            <div className="w-12 h-[1px] bg-amber-700/60 my-2"></div>
            
            {/* Clean Address Structure */}
            <div className="font-serif text-lg text-neutral-800 space-y-0.5 tracking-wide leading-relaxed">
              <p> Shraddha Colony,Near Shrikhande Hardware's</p>
              <p>Arjun Nagar, Amravati Maharashtra 444603</p>
            </div>
            <p className="text-xs text-neutral-500 font-light tracking-wide pt-1">
              Providing premium custom draping & heritage stitching across the region.
            </p>
          </div>

          {/* Right Column: Studio Hours */}
          <div className="space-y-4 max-w-md md:text-right md:items-end flex flex-col">
            <span className="text-xs font-semibold uppercase tracking-widest text-[#5c1d24] bg-[#5c1d24]/5 px-3 py-1 rounded-sm">
              वेळ • Hours
            </span>
            <h3 className="font-serif text-2xl md:text-3xl text-neutral-900 tracking-wide font-medium pt-1">
              Atelier Timings
            </h3>
            <div className="w-12 h-[1px] bg-amber-700/60 my-2 md:ml-auto"></div>
            
            {/* Clean Hours Structure */}
            <div className="font-serif text-lg text-neutral-800 space-y-0.5 tracking-wide leading-relaxed">
              <p>Monday — Sunday</p>
              <p className="text-[#5c1d24] font-medium">11:00 AM – 8:30 PM</p>
            </div>
            {/* <p className="text-xs text-amber-800 italic font-light tracking-wide pt-1">
              Mondays by prior bridal appointment only
            </p> */}
          </div>

        </div>

        {/* Minimalist Bottom Brand Accent Line */}
        <div className="mt-16 border-b border-neutral-200 w-full opacity-60"></div>
        
      </div>
    </section>
  );
};

export default LocationOverview;